





















import { Component, Prop, Vue } from 'vue-property-decorator';
import { TEntity } from '@/plugins/podolib/services/entities/Entity';
import { TAcquisition, TPatient } from '@/plugins/podolib/services/entities/EntityPatients';

import PatientAcquisitionExportationFrameWalkingOverviewGauge from '@/components/patients/acquisition/exportation/frames/walking/overview/PatientAcquisitionExportationFrameWalkingOverviewGauge.vue';
import ChartRawWalkingBanner from '@/components/charts/walking/ChartRawWalkingBanner.vue';

@Component({
  components: { ChartRawWalkingBanner, PatientAcquisitionExportationFrameWalkingOverviewGauge },
})
export default class PatientAcquisitionExportationFrameWalkingOverview extends Vue {
  @Prop({ required: true }) private patient!: TEntity<TPatient>;
  @Prop({ required: true }) private acquisition!: TEntity<TAcquisition>;
  @Prop({ required: false, default: false }) private isDegradedActivity!: TEntity<TAcquisition>;

  // -- CADENCE --------------------------------------------------------------------------------------------------------

  /*get cadence() {
    return {
      left: this.acquisition.computed_data.left.aggregates.cadence.avg * 2,
      right: this.acquisition.computed_data.right.aggregates.cadence.avg * 2
    };
  }

  get cadenceValue(): any {
    return {
      value: (this.cadence.left + this.cadence.right) / 2,
      valStatut: this.$pdc.helper!.refint.getGeneral(
        this.patient.infos.gender,
        this.$moment().diff(this.patient.infos.birthDate, 'years', false),
        'cadence',
        (this.cadence.left + this.cadence.right) / 2
      )
    };
  }

  get cadenceRange() {
    return {
      name: `${this.$t('commons.standards.cadence')} (${this.$t('commons.units.steps-min')})`,
      infos: {
        unit: 'steps/min',
        range: this.$pdc.helper!.refint.getRange(
          this.patient.infos.gender,
          this.$moment().diff(this.patient.infos.birthDate, 'years', false),
          'GENERAL',
          'cadence',
          'abs'
        )
      },
      feet: this.cadenceValue
    };
  }

  // -- WALKING SPEED --------------------------------------------------------------------------------------------------

  get walkingSpeed() {
    return {
      left: this.acquisition.computed_data.left.aggregates.walking_speed.avg,
      right: this.acquisition.computed_data.right.aggregates.walking_speed.avg
    };
  }

  get walkingSpeedValue(): any {
    return {
      value: (this.walkingSpeed.left + this.walkingSpeed.right) / 2,
      valStatut: this.$pdc.helper!.refint.getGeneral(
        this.patient.infos.gender,
        this.$moment().diff(this.patient.infos.birthDate, 'years', false),
        'speed',
        (this.walkingSpeed.left + this.walkingSpeed.right) / 2
      )
    };
  }

  get walkingSpeedRange() {
    return {
      name: `${this.$t('commons.standards.walking-speed')} (km/h)`,
      infos: {
        unit: 'km/h',
        range: this.$pdc.helper!.refint.getRange(
          this.patient.infos.gender,
          this.$moment().diff(this.patient.infos.birthDate, 'years', false),
          'GENERAL',
          'speed',
          'abs'
        )
      },
      feet: this.walkingSpeedValue
    };
  }*/
}
